import { render, staticRenderFns } from "./tracking.vue?vue&type=template&id=50a8ee1a&scoped=true&"
import script from "./tracking.vue?vue&type=script&lang=js&"
export * from "./tracking.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50a8ee1a",
  null
  
)

export default component.exports